import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { CourseSpeaker } from 'src/public/components/course-bundle-page/CourseSpeaker';
import { SpeakerDTO } from 'src/common/models/speaker';
import { media } from 'src/config/breakpoints';

const Speakers = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 2.25rem;
  margin-top: 1.25rem;

  ${media.w.min.px768(css`
    padding: 0 1.5rem;
    grid-template-columns: repeat(auto-fit, minmax(25%, 1fr));
    grid-column-gap: 1.5rem;
  `)};
`;

interface CourseBundleSpeakersProps {
  speakers: SpeakerDTO[];
}

export const CourseBundleSpeakers: FC<CourseBundleSpeakersProps> = ({ speakers }) => (
  <Speakers>
    {speakers.map((speaker) => (
      <CourseSpeaker key={speaker.id} speaker={speaker} />
    ))}
  </Speakers>
);
